import { cn } from "shadcn/lib/utils";

import { GauTerm } from "./GauTerm";

/**
 * Static rename notice shown on Usage, Spending, and Manage Plan (billing).
 * Explains AI Credits → GAUs; usage and pricing are unchanged. Renders
 * unconditionally — there is no dismissal or per-user persistence; it is
 * meant to be removed once the rename has landed with users.
 */
export function GauRenameCallout({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "flex items-start gap-2 rounded border border-border bg-muted/40 px-3 py-2 text-xs leading-4 text-muted-foreground",
        className,
      )}
      data-test="gau-rename-callout"
      role="status"
    >
      <p className="!m-0 flex-1">
        <span className="font-medium text-foreground">
          AI Credits are now called <GauTerm plural />.
        </span>{" "}
        Your usage and pricing are unchanged.
      </p>
    </div>
  );
}
